import { render, staticRenderFns } from "./PatientEditModal.vue?vue&type=template&id=ad1fe452&scoped=true&"
import script from "./PatientEditModal.vue?vue&type=script&lang=js&"
export * from "./PatientEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1fe452",
  null
  
)

export default component.exports